import request from "root/js/request";

export const postUploadPlannedStock = async ({ cabinet_id, warehouse, date }, formData) => {
  //TODO: add warehouse and date parameters: verify name
  const response = await request({
    url: `/api/analytics/wh_supply/planned_stock/`,
    method: "post",
    params: {
      cabinet_id,
    },
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Token ${localStorage.getItem("token")}`,
    },
  });
  return response;
};

export const getPlannedStock = async ({ cabinet_id }) => {
  const response = await request({
    url: `/api/analytics/wh_supply/planned_stock/`,
    method: "get",
    params: {
      cabinet_id,
    },
  });
  return response.data;
};

export const getPlannedStockBySupplyId = async ({ cabinet_id, supply_id }) => {
  const response = await request({
    url: `/api/analytics/wh_supply/planned_stock/${supply_id}/`,
    method: "get",
    params: {
      cabinet_id,
    },
  });
  return response.data;
};

export const deletePlannedStockBySupplyId = async ({ cabinet_id, supply_id }) => {
  try {
    const response = await request({
      url: `/api/analytics/wh_supply/planned_stock/${supply_id}/`,
      method: "delete",
      params: {
        cabinet_id,
      },
    });
    return response; // возвращается целиком response, чтобы чекать status
  } catch (error) {
    return error.response;
  }
};
